import React from "react"
import VacationFlag from "../../../components/molecules/VacationFlag.molecule"

const VacationTitle = ({ schemaTitle }) => {
  return (
    <div className="flex gap-1">
      <VacationFlag schemaTitle={schemaTitle} />
      <span>{schemaTitle}</span>
    </div>
  )
}

export default VacationTitle
